import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const Page = lazy(() => import('~/features/samtek/sub-guide/page-client'))

export const Route = createFileRoute('/_authed/samtek/staffs/sub-guide')({
  component: () => <Suspense fallback={null}><Page /></Suspense>,
})
